import { useAuthStore } from '@/stores/auth'
import type { Directive } from 'vue'

export const permission: Directive = {
  mounted(el, binding) {
    const { value } = binding
    const authStore = useAuthStore()

    if (value && typeof value === 'string') {
      if (!authStore.hasPermission(value)) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      throw new Error(`need permissions! Like v-permission="'profiles.edit_profile'"`)
    }
  },
}
